import React, { useEffect, useState } from 'react';

import { EmbedService, Messages } from '../../core/services/embedService';
import { Cookies, CookieService } from '../../core/services/cookieService';
import Title from '../Title/Title';
import GetMobileApp from '../AdditionalInfo/GetMobileApp';
import AuthButton from '../AuthButton/AuthButton';
import { LoadingSpinner } from '../RedirectChecker/RedirectChecker';

import '../CompletedForms/CompletedForms.scss';
import { getRedirectTo } from '../../utilities/getRedirectTo';
import { getSsoRoute } from '../../utilities/getSsoRoute';

const PasswordResetSuccess = ({
  embedService = EmbedService.Instance(),
  cookieService = CookieService.Instance()
}) => {
  const [accessToken, setAccessToken] = useState('');

  useEffect(() => {
    (async () => {
      const rawAccessToken = await cookieService.getRaw(Cookies.USCCA_Access);
      setAccessToken(rawAccessToken);
    })();
  }, []);

  return accessToken ? (
    <div className="mt-5">
      <Title name="SUCCESS!" />

      <p className="form-text">
        We have updated your password. Click the button below to access{' '}
        your USCCA Dashboard and preview the exceptional training content available to our Members.
      </p>

      {embedService.isEmbedded ? (
        <AuthButton
          id="myAccountButton"
          color="btn-gold"
          text="Continue"
          onClick={() => {
            embedService.messageParent(Messages.Redirect, {
              action: 'login',
              redirect_url: getRedirectTo()
            });
          }}
        />
      ) : (
        <>
          <form
            className="secret-form"
            method="POST"
            action={getSsoRoute()}
          >
            <input type="text" name="action" value="login" readOnly />
            <input type="text" name="redirectTo" value={getRedirectTo()} readOnly />
            <input type="text" name="uscca_access" value={accessToken} readOnly />
            <AuthButton id="myAccountButton" color="btn-gold" text="Continue" />
          </form>
          <GetMobileApp />
        </>
      )}
    </div>
  ) : (
    <LoadingSpinner />
  );
};

export default PasswordResetSuccess;
